import _LoadingOutlined from "@zenlayer/zen-design-icons/assets/LoadingOutlined.svg";
import _suggestCloseCircleFill from "@zenlayer/zen-design-icons/assets/suggest/CloseCircleFill.svg";
import _suggestWarningFill from "@zenlayer/zen-design-icons/assets/suggest/WarningFill.svg";
import _suggestInfoCircleFill from "@zenlayer/zen-design-icons/assets/suggest/InfoCircleFill.svg";
import _suggestCheckCircleFill from "@zenlayer/zen-design-icons/assets/suggest/CheckCircleFill.svg";
import React from 'react';
import { message } from 'antd';
import Icon from '../icon';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
const prefixClass = 'zen-design'; // TODO
const baseClassName = "".concat(prefixClass, "-message");
const Icons = {
  success: /*#__PURE__*/_jsx(Icon, {
    type: "suggest/CheckCircleFill"
  }),
  info: /*#__PURE__*/_jsx(Icon, {
    type: "suggest/InfoCircleFill"
  }),
  warning: /*#__PURE__*/_jsx(Icon, {
    type: "suggest/WarningFill"
  }),
  error: /*#__PURE__*/_jsx(Icon, {
    type: "suggest/CloseCircleFill"
  }),
  loading: /*#__PURE__*/_jsx(Icon, {
    type: "LoadingOutlined"
  })
};
const setConfig = (config, type) => {
  const {
    className,
    ...otherConfig
  } = config;
  const defaultConfig = {
    className: classNames(className, baseClassName, "".concat(baseClassName, "-").concat(type)),
    icon: /*#__PURE__*/React.cloneElement(Icons[type], {
      className: 'messageIcon'
    }),
    type,
    ...otherConfig
  };
  return defaultConfig;
};
const MessageInstance = {
  success: config => {
    const newConfig = setConfig(config, 'success');
    return message.open(newConfig);
  },
  info: config => {
    const newConfig = setConfig(config, 'info');
    return message.open(newConfig);
  },
  warning: config => {
    const newConfig = setConfig(config, 'warning');
    return message.open(newConfig);
  },
  error: config => {
    const newConfig = setConfig(config, 'error');
    return message.open(newConfig);
  },
  loading: config => {
    const newConfig = setConfig(config, 'loading');
    return message.open(newConfig);
  },
  destroy: message.destroy
};
export default MessageInstance;